export const AIToolsTableStyles = {
  table: {
    style: {
      backgroundColor: "#081245",
      color: "#ffffff",
      border: "1px  solid #6b7280",

      borderRadius: "8px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#081245",
      borderBottom: "1px solid #6b7280",
      borderRadius: "8px 8px 0 0",
    },
  },
  headCells: {
    style: {
      color: "#e5e7eb",
      fontSize: "14px",
      fontWeight: "600",
    },
  },
  rows: {
    style: {
      backgroundColor: "#081245 !important",
      borderBottomColor: "#5f5f5f53 !important",
      "&:hover": {
        backgroundColor: "#0a1555 !important", // Force override with !important
      },
      "&:nth-of-type(odd)": {
        backgroundColor: "#081245 !important",
      },
      "&:nth-of-type(even)": {
        backgroundColor: "#081245 !important",
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: "#0a1555 !important",
      borderBottomColor: "#374151",
      borderRadius: "0px",
      outline: "none",
    },
  },
  pagination: {
    style: {
      backgroundColor: "#081245",
      border: "1px solid #6b7280",
      borderTop: "0px",
      color: "#ffffff !important",
      borderRadius: "0 0 8px 8px",
    },
    pageButtonsStyle: {
      backgroundColor: "#081245 !important",
      color: "#ffffff !important",
      fill: "#ffffff !important", // For icons if any
      "&:hover": {
        backgroundColor: "#0a1555 !important",
        color: "#ffffff !important",
        fill: "#ffffff !important",
      },
      "& span": {
        color: "#ffffff !important",
      },
    },
  },
  noData: {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff !important",
      backgroundColor: "#081245 !important",
    },
  },
  progress: {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff !important",
      backgroundColor: "#081245 !important",
    },
  },
};
export  const leadsStyles = {
    table: {
      style: {
        backgroundColor: "transparent",
        minWidth: "1000px",
      },
    },
    tableWrapper: {
      style: {
        backgroundColor: "transparent",
        overflowX: "auto",
      },
    },
    head: {
      style: {
        backgroundColor: "transparent",
        borderBottomColor: "#475569",
        borderBottomWidth: "1px",
      },
    },
    headRow: {
      style: {
        backgroundColor: "transparent",
        borderBottomColor: "#475569",
      },
    },
    headCells: {
      style: {
        color: "#9CA3AF",
        fontSize: "14px",
        fontWeight: "500",
        paddingLeft: "16px",
        paddingRight: "16px",
        backgroundColor: "transparent",
      },
    },
    rows: {
      style: {
        backgroundColor: "transparent",
        borderBottomColor: "#475569",
        borderBottomWidth: "1px",
        "&:hover": {
          backgroundColor: "rgba(51, 65, 85, 0.5)",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        backgroundColor: "transparent",
      },
    },
    pagination: {
      style: {
        backgroundColor: "transparent",
        borderTopColor: "#475569",
        color: "#9CA3AF",
      },
      pageButtonsStyle: {
        backgroundColor: "#334155 !important",
        border: "1px solid #475569 !important",
        color: "#E2E8F0 !important",
        fill: "#E2E8F0 !important",
        "&:hover": {
          backgroundColor: "#475569",
          color: "#E2E8F0 !important",
          fill: "#fff !important",
        },
        "&:disabled": {
          opacity: 0.5,
          cursor: "not-allowed",
        },
      },
    },
  };